// extracted by mini-css-extract-plugin
export var active = "_2g-7";
export var backButton = "_2g-6";
export var clone = "_2g-c";
export var collapseBar = "_2g-g";
export var collapseMode = "_2g-i";
export var dragHandle = "_2g-a";
export var dropdownIcon = "_2g-e";
export var hidden = "_2g-o";
export var iconContainer = "_2g-l";
export var iconSwapper = "_2g-n";
export var navItem = "_2g-4";
export var navItemIcon = "_2g-d";
export var navProfile = "_2g-5";
export var notificationDot = "_2g-m";
export var optionsContainer = "_2g-f";
export var primaryNav = "_2g-0";
export var primaryTab = "_2g-j";
export var secondaryNav = "_2g-1";
export var selected = "_2g-k";
export var settingsNav = "_2g-2";
export var settingsNavItems = "_2g-3";
export var show = "_2g-b";
export var sideNav = "_2g-h";
export var teamItem = "_2g-8";
export var userProfileItem = "_2g-9";